import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioSummary = ({ totalBalance, totalGain, totalGainPercentage, cryptoBalance, usdBalance }) => {
  const isPositive = totalGain >= 0;
  const [showAddress, setShowAddress] = useState(false);
  const walletAddress = 'bc1qrgheqp924523dnp65a6rq2c9ul2xywp30y4g2w';

  const handleGenerateAddress = () => {
    setShowAddress(true);
  };

  const handleCopyAddress = () => {
    navigator.clipboard?.writeText(walletAddress);
  };

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-6 md:p-8 lg:p-10 text-white shadow-xl">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <p className="text-sm md:text-base opacity-90 mb-2">Total Portfolio Value</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">${totalBalance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h2>
        </div>
        <div className="bg-white/20 backdrop-blur-sm rounded-full p-3 md:p-4">
          <Icon name="Wallet" size={32} color="#FFFFFF" />
        </div>
      </div>

      {/* Wallet Address Section */}
      <div className="mb-6 md:mb-8">
        {!showAddress ? (
          <button
            onClick={handleGenerateAddress}
            className="flex items-center gap-2 px-4 py-2 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-lg transition-all duration-200"
          >
            <Icon name="Key" size={16} color="#FFFFFF" />
            <span className="text-sm md:text-base font-medium">Generate Wallet Address</span>
          </button>
        ) : (
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
            <div className="flex items-center justify-between mb-2">
              <p className="text-xs md:text-sm opacity-80 font-medium">Your Wallet Address</p>
              <button
                onClick={handleCopyAddress}
                className="flex items-center gap-1 px-2 py-1 bg-white/20 hover:bg-white/30 rounded transition-all duration-200"
              >
                <Icon name="Copy" size={14} color="#FFFFFF" />
                <span className="text-xs">Copy</span>
              </button>
            </div>
            <p className="text-sm md:text-base font-mono break-all">{walletAddress}</p>
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 mb-6 md:mb-8">
        <div className={`flex items-center gap-1 px-3 py-1.5 rounded-full ${isPositive ? 'bg-success/20' : 'bg-error/20'}`}>
          <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={16} color="#FFFFFF" />
          <span className="text-sm md:text-base font-semibold">{isPositive ? '+' : ''}{totalGainPercentage?.toFixed(2)}%</span>
        </div>
        <span className="text-sm md:text-base opacity-90">
          {isPositive ? '+' : ''}{totalGain?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })} Today
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 md:gap-6">
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Bitcoin" size={20} color="#FFFFFF" />
            <p className="text-xs md:text-sm opacity-80">Crypto Assets</p>
          </div>
          <p className="text-xl md:text-2xl font-bold">${cryptoBalance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="DollarSign" size={20} color="#FFFFFF" />
            <p className="text-xs md:text-sm opacity-80">USD Balance</p>
          </div>
          <p className="text-xl md:text-2xl font-bold">${usdBalance?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSummary;